export const SUPPORT_HELPER_EXACT_PATHS = new Set(["/contact", "/cart"]);
export const SUPPORT_HELPER_PREFIXES = ["/cart/"];
export const SUPPORT_HELPER_HIDDEN_PREFIXES = ["/ai-astrologer", "/ai-kundli"];

export const STICKY_CHAT_HIDDEN_PREFIXES = [
  "/free-kundali",
  "/ai-astrologer",
  "/auth",
  "/account",
  "/checkout",
  "/ops",
  "/reports",
];

// Home already renders InlineChatPreview + KundaliFormCard inline; the floating
// CTA at bottom-[76px] right-4 lands on top of the form's Generate button on a
// 375×812 viewport. Suppress on the exact `/` path while keeping the sticky for
// the rest of the SEO tail.
export const STICKY_CHAT_HIDDEN_EXACT = new Set(["/"]);

export function normalizeOverlayPath(pathname: string | null | undefined) {
  if (!pathname) return "/";
  return pathname.replace(/\/+$/, "") || "/";
}

function hasQueryParam(
  searchParams: URLSearchParams | ReadonlyURLSearchParamsLike | null | undefined,
  key: string
) {
  return Boolean(searchParams?.has(key));
}

export type ReadonlyURLSearchParamsLike = Pick<URLSearchParams, "has">;

export function shouldShowSupportHelper(
  pathname: string | null | undefined,
  searchParams?: URLSearchParams | ReadonlyURLSearchParamsLike | null
) {
  const path = normalizeOverlayPath(pathname);
  if (
    SUPPORT_HELPER_HIDDEN_PREFIXES.some(
      (prefix) => path === prefix || path.startsWith(`${prefix}/`)
    )
  ) {
    return false;
  }

  const isSupportPath =
    SUPPORT_HELPER_EXACT_PATHS.has(path) ||
    SUPPORT_HELPER_PREFIXES.some((prefix) => path.startsWith(prefix));
  const isReportRecovery =
    path === "/free-kundali" &&
    (hasQueryParam(searchParams, "post_purchase_report") || hasQueryParam(searchParams, "order"));

  return isSupportPath || isReportRecovery;
}

export function shouldShowStickyChatButton(pathname: string | null | undefined) {
  const path = normalizeOverlayPath(pathname);
  if (STICKY_CHAT_HIDDEN_EXACT.has(path)) return false;
  return !STICKY_CHAT_HIDDEN_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
}
